<template>
    <div class="box">
        <div class="row">
            <div class="col-9">
                <div class="row">
                    <div class="col-6"
                        v-for="template in uniqueTemplates"
                        :key="template.id"
                    >
                        <scenario-template-item v-bind:id="template.id" />
                    </div>
                </div>
            </div>

            <div class="col-3">
                <div class="row">
                    <div class="col-10">
                        <change-info @trigger-change-info="$emit('trigger-change-info')"/>
                    </div>
                </div>
            </div>

        </div>
        <div class="row mr-3">
            <div class="col-12 mb-3">
                <button class="btn btn-primary pull-right btn-lg" @click="accept">
                    {{resource('DmVisualizer_Accept_Data_Button_Text')}}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import dmVisualizerApi from '../../../../Api/dm-visualizer'
    import growler from "../../../../Util/growler";
    import {RouteNames} from "@modules/DmVisualizer/constants";

    import resourceMixin from '../../../../Util/Mixins/resources'
    
    import ScenarioTemplateItem from "./ScenarioTemplateItem.vue";
    import ScenarioTemplatesChangeInfo from "./ScenarioTemplatesChangeInfo.vue";
    
    export default {
        name: "scenario-templates",
        
        mixins: [resourceMixin],
        
        components: {
            ScenarioTemplateItem,
            'ChangeInfo': ScenarioTemplatesChangeInfo
        },
        
        props: {
            scenarioIds: {
                type: Array,
                required: true
            }
        },
        
        computed: {
            uniqueTemplates(){
                const processedKeys = {};
                const uniqueTemplates = [];
                
                this.templates.forEach(template => {
                    if(!processedKeys[template.id]){
                        processedKeys[template.id] = true;
                        uniqueTemplates.push(template);
                    }
                });
                
                return uniqueTemplates;
            }
        },
        
        data() {
            return {
                templates: []
            };
        },

        created() {
            const vm = this;

            vm.scenarioIds.forEach(scenarioId => {
                dmVisualizerApi.getTemplatesByScenario(scenarioId).then(
                    scenario => vm.templates.push(...scenario.templates),
                    err => growler.error(err.join('\n'))
                );
            });
        },

        methods: {
            accept() {
                const vm = this;

                //DmVisualizer_AcceptScenarioSelection_SuccessNotification
                dmVisualizerApi.acceptScenarioSelection(vm.scenarioIds).then(
                    () => {
                        growler.bootstrapSuccess(this.resource('DmVisualizer_AcceptScenarioSelection_SuccessNotification'));
                        
                        this.$router.push({
                            name: RouteNames.INDEX,
                            query: { divisionId: this.$route.query && this.$route.query.divisionId }
                        });
                    },
                    err => growler.bootstrapDanger(err.join('\n'))
                )
            }
        }
    };
</script>

<style scoped src="../../Style/scenario-templates.scss" lang="scss">

</style>
